import React from 'react';
import { Clock } from 'lucide-react';

// 2026-09-22: the CEO asked whether the INSPECTIONS column was same-day conversions.
// It never was — on the reference ad exactly 1 of 26 payments landed the same day —
// so the page now SHOWS the wait instead of leaving it to be guessed.
const BUCKETS = [
  { key: 'same_day', label: 'Same day', bar: 'bg-emerald-500', chip: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  { key: 'd1_7', label: '1-7 days', bar: 'bg-sky-500', chip: 'bg-sky-50 text-sky-700 border-sky-200' },
  { key: 'd8_30', label: '8-30 days', bar: 'bg-amber-500', chip: 'bg-amber-50 text-amber-700 border-amber-200' },
  { key: 'd31_90', label: '31-90 days', bar: 'bg-orange-500', chip: 'bg-orange-50 text-orange-700 border-orange-200' },
  { key: 'd90_plus', label: '90+ days', bar: 'bg-rose-500', chip: 'bg-rose-50 text-rose-700 border-rose-200' },
];

export const ConversionLagBar = ({ lag, medianDays, testId = 'conversion-lag' }) => {
  const total = BUCKETS.reduce((sum, b) => sum + (lag?.[b.key] || 0), 0);
  if (!total) return null;

  return (
    <div className="max-w-2xl" data-testid={testId}>
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-2">
        <h4 className="text-sm font-semibold text-gray-900 flex items-center gap-1.5">
          <Clock className="h-3.5 w-3.5 text-gray-400" />
          How long the money took to arrive
        </h4>
        <span className="text-xs text-gray-500">
          {medianDays === 0 || medianDays
            ? `typically ${medianDays} day${medianDays === 1 ? '' : 's'} after the lead`
            : ''}
        </span>
      </div>

      <div className="flex h-2 w-full overflow-hidden rounded-full bg-gray-200 mb-2">
        {BUCKETS.map((b) => {
          const n = lag?.[b.key] || 0;
          if (!n) return null;
          return (
            <div
              key={b.key}
              style={{ width: `${(n / total) * 100}%` }}
              className={b.bar}
              title={`${b.label} — ${n} of ${total} payments`}
            />
          );
        })}
      </div>

      <div className="flex flex-wrap gap-2">
        {BUCKETS.map((b) => {
          const n = lag?.[b.key] || 0;
          if (!n) return null;
          return (
            <span
              key={b.key}
              className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs ${b.chip}`}
              data-testid={`${testId}-${b.key}`}
            >
              <span className="font-semibold">{b.label}</span>
              <span className="font-bold tabular-nums">{n}</span>
              <span className="tabular-nums opacity-70">({Math.round((n / total) * 100)}%)</span>
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default ConversionLagBar;
